export default "__VITE_ASSET__D44AbaIK__"